import React from 'react';
import { Link } from 'react-router-dom';

export default function CategoryNode({ category, expandedCategories, onToggle, onEdit, onDelete }) {
  const isExpanded = expandedCategories.has(category.id);
  const hasChildren = category.sub_classifications && category.sub_classifications.length > 0;

  return (
    <li className="my-1 list-none group">
      <div className="flex items-center p-2 bg-gray-100 rounded hover:bg-gray-200 transition-colors">
        <span 
          className="w-6 text-center cursor-pointer"
          onClick={() => hasChildren && onToggle(category.id)}
        >
          {hasChildren && (isExpanded ? '▼' : '▶')}
        </span>
        
        <Link to={`/categories/${category.id}/offers`} className="flex-grow">
            <span className="font-semibold">{category.english_name}</span>
            <span className="text-sm text-gray-500 ml-2">({category.arabic_name})</span>
        </Link>
        
        <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="text-xs text-blue-500 bg-blue-100 rounded-full px-2 py-1 ml-4">{category.offer_counts || 0} offers</span>
            <button onClick={() => onEdit(category)} className="text-blue-600 hover:text-blue-800 text-sm">Edit</button>
            <button onClick={() => onDelete(category.id)} className="text-red-600 hover:text-red-800 text-sm">Delete</button>
        </div>
      </div>

      {hasChildren && isExpanded && (
        <ul className="pl-6 border-l-2 border-gray-200 ml-3">
          {category.sub_classifications.map(childCategory => (
            <CategoryNode 
                key={childCategory.id} 
                category={childCategory} 
                expandedCategories={expandedCategories}
                onToggle={onToggle}
                onEdit={onEdit}
                onDelete={onDelete}
            />
          ))}
        </ul>
      )}
    </li>
  );
}